export const genderData = [
  {text: 'Male', value: 'MALE'},
  {text: 'Female', value: 'FEMALE'},
  {text: 'Undifferentiated', value: 'UNDIFFERENTIATED'}
];
